var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{attrs:{"color":"grey darken-1 white--text text-caption"}},[_c('v-spacer'),_c('v-col',{attrs:{"cols":"auto"}},[_c('router-link',{attrs:{"to":"/tos"}},[_vm._v("利用規約／プライバシーポリシー")])],1),_c('v-spacer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }